// Who is typing into a session through the API (the `driven` event: an agent driving it with `cmx tmux` or `cmx
// send`, at most every 500 ms while it lasts). The pane showing it says so in its tab bar until 3 s after the last.

import { useSyncExternalStore } from 'react';

/** How long a pane keeps saying who drove it after the last input. */
export const DRIVEN_MS = 3000;

const by = new Map<number, { who: string; timer: ReturnType<typeof setTimeout> }>();
const listeners = new Set<() => void>();
const tell = () => listeners.forEach((l) => l());

export function heardDriven(sid: number, who: string) {
  const was = by.get(sid);
  if (was) clearTimeout(was.timer);
  const timer = setTimeout(() => {
    by.delete(sid);
    tell();
  }, DRIVEN_MS);
  const name = who || 'an agent';
  by.set(sid, { who: name, timer });
  if (was?.who !== name) tell();
}

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => void listeners.delete(l);
};

/** Who is driving session `sid` now ("Claude Code", "an agent"), or null. */
export const useDriven = (sid: number | undefined): string | null =>
  useSyncExternalStore(subscribe, () => (sid === undefined ? null : (by.get(sid)?.who ?? null)));
